/* eslint-disable no-unused-vars */
import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import map from '../static/map.png'
import {
  Header,
  HeaderParagraph,
  CardComponent,
  Footer,
  Container,
  ContainerTitle,
  ContainerSubTitle,
  Button,
  Icon,
  Input,
  BodyWrapper,
  MobileFooter
} from '../components'
const MobileClientLogo = styled.li``

const TopWrapper = styled.div`
  max-width: 1366px;
  margin: 0 auto;
  @media (max-width: 768px) {
    padding: 40px 16px 20px;
    & > h1 {
      font-size: 28px !important;
      line-height: normal !important;
      letter-spacing: normal !important;
    }
    & > p {
      font-size: 16px !important;
      font-weight: 300 !important;
      line-height: 1.38 !important;
      letter-spacing: 0.1px !important;
    }
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 80px 250px 60px 80px;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  & > p {
    text-align: left;
    padding: 0;
    padding-top: 10px;
    font-size: 18px;
    font-weight: 300;
    line-height: 1.61;
  }
  & > h1 {
    font-size: 48px;
    line-height: 1.27;
    color: #333333;
  }
`
const ImageWrapper = styled.div`
  & > img {
    width: 100%;
    height: 400px;
    object-fit: cover;
  }
  @media (max-width: 768px) {
    & > img {
      height: 200px;
    }
  }
`
const SpecializationWrapper = styled.div`
  width: 100%;
  max-width: 1366px;
  padding: 0 80px;
  @media (max-width: 992px) {
    padding: 0;
  }
  @media (max-width: 768px) {
    padding-top: 30px;
    & > div {
      flex-wrap: wrap;
      & > div {
        padding: 40px 20px !important;
      }
    }
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 80px;
  & > *:nth-child(1) {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    & > *:nth-child(1) {
      border-right: none;
      border-left: none;
      border-top: none;
    }
    & > *:nth-child(2) {
      border-top: none;
    }
    & > *:nth-child(3) {
      border-right: none;
      border-left: none;
      border-top: none;
    }
    & > *:nth-child(4) {
      border: none;
    }
    & > *:nth-child(5) {
      border-bottom: none;
      border-top: none;
    }
    & > *:nth-child(6) {
      border: none;
    }
    @media (max-width: 768px) {
      & > *:nth-child(1) {
        border-right: none;
        border-left: none;
        border-top: none;
      }
      & > *:nth-child(2) {
        border-top: none;
        border-right: none;
      }
      & > *:nth-child(3) {
        border-right: none;
        border-left: none;
        border-top: none;
      }
      & > *:nth-child(4) {
        border: none;
        border-left: 1px solid #f0ecec;
        border-bottom: 1px solid #f0ecec;
      }
      & > *:nth-child(5) {
        border: none;
      }
      & > *:nth-child(6) {
        border: none;
        border-left: 1px solid #f0ecec;
      }
    }
    @media (max-width: 520px) {
      & > *:nth-child(1) {
        border-top: 1px solid #f0ecec;
      }
      & > * {
        border-bottom: 1px solid #f0ecec !important;
        border-right: 1px solid #f0ecec !important;
        border-left: 1px solid #f0ecec !important;
      }
    }
  }
`

const LinksWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-top: 4px;
  & > a {
    margin-right: 20px;
  }
  & > a:hover {
    & path {
      fill: #35cc62;
    }
  }
`
const LinkImagesWrapper = styled.div`
  display: flex;
  padding-top: 0px;
  width: 100%;
  justify-content: space-between;
  & > div {
    flex-basis: calc(50% - 5px);
  }
  & > div:nth-child(1) {
    display: flex;
    flex-direction: column;
    & img {
      width: 100%;
      height: auto;
      object-fit: contain;
      padding-bottom: 15px;
    }
  }
  & > div:nth-child(2) {
    display: flex;
    flex-direction: column;
    & img {
      width: 100%;
      height: auto;
      object-fit: contain;
      padding-bottom: 15px;
      align-self: flex-end;
    }
  }
`
const BottomTextWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-top: 25px;
  & > div:nth-child(1) {
    display: flex;
    flex-direction: column;
    flex-basis: 70%;
    & > p:nth-child(1) {
      font-size: 20px;
      font-weight: normal;
      line-height: 1.52;
      color: #333333;
    }
    & > p:nth-child(2) {
      font-size: 16px;
      font-weight: normal;
      line-height: 1.88;
      letter-spacing: 0.1px;
      padding-top: 15px;
    }
  }
  & > div:nth-child(2) {
    flex-basis: 30%;
    padding-left: 100px;
  }
  @media (max-width: 768px) {
    & > div {
      flex-basis: 100% !important;
    }
    & > div:last-child {
      padding-left: 0 !important;
      & > div {
        margin-bottom: 10px;
      }
    }
  }
`
const ContentWrapper = styled.div`
  max-width: 2560px;
  margin: 0 auto;
`
const GalleryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1024px;
  margin: 0 auto;
`
const SmallHeader = styled.div`
  margin-bottom: 30px;
  & > p:nth-child(1) {
    font-size: 16px;
    font-weight: normal;
    line-height: 1.63;
    color: #333333;
  }
  & > p:nth-child(2) {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.64;
    letter-spacing: 0.1px;
    color: #999999;
    padding-top: 6px;
  }
`
const Gallerylink = styled.div`
  padding: 0px 0 0 0;
  text-transform: uppercase;
  font-size: 13px;
  width: 100%;
  max-width: 1024px;
  margin: 0 auto;
  transition: all 1s;
  & ul {
    margin: 0;
    padding: 0;
    @media (max-width: 540px) {
      padding-bottom: 20px;
    }
  }
  @media (max-width: 600px) and (min-width: 540px) {
    font-size: 12px;
  }
`

const List = styled.li`
  list-style: none;
  display: inline-block;
  padding: 20px 30px;
  cursor: pointer;
  color: ${props => (props.active ? '#3fd06f' : 'black')};
  @media (max-width: 600px) and (min-width: 540px) {
    padding: 20px 20px;
  }
  @media (max-width: 540px) {
    padding: 14px 10px 0 0;
    text-align: center;
  }
  :first-child {
    padding-left: 15px;
    @media (max-width: 540px) {
      padding-left: 0;
    }
  }
`
const ButtonHolder = styled.div`
  margin-top: 40px;
`
const Overlaybox = styled.div`
  position: absolute;
  top: 0px;
  bottom: 20px;
  left: 0px;
  right: 0px;
  background: #f64560d9; /* fallback for old browsers */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  color: #fff;
  transform: scale(0, 0);
  transition: all 0.6s;
  p {
    text-align: center;
  }
`
const HoverWrapper = styled.div`
  position: relative;
  :hover div {
    transform: scale(1, 1);
  }
`

const OurClient = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 1366px;
  margin: auto;
  padding: 0 80px;
  @media (max-width: 992px) {
    padding: 0;
  }
  & ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    padding: 0;
    margin: 0;
    justify-content: center;
    & li {
      width: calc(100% / 5);
      text-align: center;
      list-style-type: none;
      padding: 20px 40px;
      display: flex;
      height: 140px;
      justify-content: center;

      @media (max-width: 992px) {
        width: calc(100% / 3);
      }
      @media (max-width: 520px) {
        width: calc(100% / 2);
      }
      &:hover {
        & img {
          filter: grayscale(0);
        }
      }
      & a {
        display: flex;
      }
      & img {
        width: 120px;
        object-fit: contain;
        position: relative;
        /* filter: grayscale(100%); */
      }
      @media (max-width: 768px) {
        & > img {
          height: 120px;
          object-fit: contain;
        }
      }
    }
  }
`
const Backgroundwrapper = styled.div`
  background-image: url(${map});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  max-width: 100%;
  // height: 500px;
  @media (max-width: 768px) {
    & > div:nth-child(2) {
      display: none;
    }
    display: flex;
    flex-direction: column;
    height: 100%;
    & > button {
      align-self: center;
      position: relative;
      padding: 0;
      padding-right: 14px;
      -webkit-tap-highlight-color: transparent;
      &:after {
        content: '';
        width: 8px;
        height: 8px;
        position: absolute;
        border-left: 2px solid #333333;
        border-bottom: 2px solid #333333;
        transform: ${props => (props.rotate ? 'rotate(135deg)' : 'rotate(-45deg)')};
        margin-left: 6px;
        bottom: ${props => (props.rotate ? 12 : 16)}px;
      }
    }
  }
`
const Container2 = styled.section`
  padding: ${props => (props.padding ? props.padding : '60px 80px')};
  background: ${props => (props.background ? props.background : '#fff')};
  display: flex;
  flex-direction: column;
  align-items: ${props => (props.normal ? 'center' : 'center')};
  margin: ${props => (props.margin ? props.margin : '0px')};
  width: 100%;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 768px) {
    padding: 40px 20px;
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`
const FormWrapper = styled.form`
  display: flex;
  @media (max-width: 520px) {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
    & > div > input {
      width: 100%;
      margin-bottom: 10px;
    }
    & > button {
      width: 100%;
      border-radius 4px;
    }
  }
`

export class Services extends Component {
  state = {
    activeBlock: 'Mtech'
  }

  handleActive = event => {
    console.log('event', event)
    this.setState({ activeBlock: event })
  }
  render() {
    return (
      <Fragment>
        <Header />
        <ContentWrapper>
          <TopWrapper>
            <HeaderParagraph
              headerColor={'#333333'}
              headerFontSize={'38px'}
              header={'Services'}
              paragraph={
                '8om Internet helps businesses automate their processes and allow them to take decisions based on real time data.'
              }
            />
          </TopWrapper>
          <ImageWrapper>
            <img src={require('../static/about_us.jpg')} alt="Services" />
          </ImageWrapper>
          <Container padding={'80px 0px'}>
            <ContainerTitle>Specialisation</ContainerTitle>
            <ContainerSubTitle>
              Let's have a look at how our oraganisation can bring you the best solutions.
            </ContainerSubTitle>
            <SpecializationWrapper>
              <div>
                <CardComponent
                  parentLink="https://8om.io/services/web-development"
                  img={require('../static/webdevelopment2.png')}
                  alt="Web Development"
                  smallHeading="Web Development"
                  description="Easy tracking of inventory from the factory to the customer; accurate real-time information on stocks of channel partners allowing for an increase."
                />

                <CardComponent
                  parentLink="https://8om.io/services/app-development"
                  img={require('../static/appdevelopment.png')}
                  alt="App Development"
                  smallHeading="App Development"
                  description="Discovering data feed and vital information, fetching ecommerce products, closely monitoring competitors across industries."
                />
                <CardComponent
                  parentLink="https://8om.io/services/experiential-marketing"
                  img={require('../static/experientialmarketing.png')}
                  alt="Experiential Marketing"
                  smallHeading="Experiential Marketing"
                  description="Our platform enables you to find leads in your target market and augment inhouse leads with data gathered from various online sources."
                />
                <CardComponent
                  parentLink="https://8om.io/services/digital-marketing"
                  img={require('../static/digitalmarketing.png')}
                  alt="Digital Marketing"
                  smallHeading="Digital Marketing"
                  description="We believe in research driven design. Analysing target market and user base to create the best user experince for the website or application."
                />
                <CardComponent
                  parentLink="https://8om.io/services/web-crawling"
                  img={require('../static/datamining.png')}
                  alt="Web Crawling"
                  smallHeading="Web Crawling"
                  description="We devise and dispense digital marketing strategies to boost your brand. Indulge in advanced business analysis with our services."
                />
                <CardComponent
                  parentLink="https://8om.io/services/ux-ui"
                  img={require('../static/uxui.png')}
                  alt="UI/UX"
                  smallHeading="UI/UX"
                  description="Bespoke automation of your business processes enabling you to scale, brought to you by our skilled team that has gained its expertise from 10+ different industries."
                />
              </div>
            </SpecializationWrapper>
          </Container>
          <Container background="#fafbfc" padding={'50px 0'}>
            <ContainerTitle>Get In Touch</ContainerTitle>
            <ContainerSubTitle paddingBottom="30px">
              Give your business the best tools to optimize your processes.
            </ContainerSubTitle>
            <form action="/contact" method="POST">
              <FormWrapper>
                <Input type="email" name="_replyto" icon="email" placeholder="Email" changeColor={'#35cc62'} />

                <Button
                  radius={'0 4px 4px 0'}
                  title={'Contact Us'}
                  background={'#35cc62'}
                  type="submit"
                  formAction="/contact"
                  method="POST"
                />
              </FormWrapper>
            </form>
          </Container>

          <Container2 normal background={'#fafbfc'} padding={'80px 0 80px 0'}>
            <ContainerTitle>Our Clients Around The World</ContainerTitle>
            <ContainerSubTitle>
              Our clients are valuable to us and we’re always inspired by them and their need to make their business
              better.
            </ContainerSubTitle>
            <Backgroundwrapper>
              <OurClient>
                <ul>
                  <li>
                    <img src={require('../static/client_logo/baked-pizza.jpg')} alt="Baked" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/resplendentcosmetics.png')} alt="Resplendent Cosmetics" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/tanoshiitrail.png')} alt="Tanoshii Trail" />
                  </li>

                  <li>
                    <img src={require('../static/client_logo/m-tech.jpg')} alt="M-tech" />
                  </li>

                  <li>
                    <img src={require('../static/client_logo/munafamart.png')} alt="Munafamart" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/teafloor.png')} alt="Teafloor" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/vikas_spools.jpg')} alt="Vikas Spools" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/techrobotix.png')} alt="Techrobtix" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/phone.png')} alt="Phono Retail" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/bng.png')} alt="Blue n Greys" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/beccos.jpg')} alt="Beccos" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/erosgroup.png')} alt="Beccos" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/bonobology.jpg')} alt="Beccos" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/canon.png')} alt="Beccos" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/creatanium.png')} alt="Beccos" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/dubaipetroleum.png')} alt="Beccos" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/garagecafe.png')} alt="Beccos" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/ges.png')} alt="Beccos" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/golds.png')} alt="Beccos" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/governmentsarjah.png')} alt="Beccos" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/leverage_group.jpg')} alt="Beccos" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/greenchoice.png')} alt="Beccos" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/fractal.png')} alt="Beccos" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/home_registry.jpg')} alt="Beccos" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/huawei.png')} alt="Beccos" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/scale_labs.jpg')} alt="Beccos" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/pico.png')} alt="Beccos" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/truly_madly.jpg')} alt="Beccos" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/saudiaramco.png')} alt="Beccos" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/wickey.jpg')} alt="Beccos" />
                  </li>
                </ul>
              </OurClient>
            </Backgroundwrapper>
          </Container2>
        </ContentWrapper>
        <BodyWrapper>
          <Footer />
          <MobileFooter />
        </BodyWrapper>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Services.js